export default {"src":"/_next/static/media/jotun.fc5ed3be.svg","height":121,"width":170,"blurWidth":0,"blurHeight":0};